module.exports = {"0":"пн","1":"вт","2":"ср","3":"чт","4":"пт","5":"сб","6":"вс"}


//////////////////
// WEBPACK FOOTER
// ./frontend/src/modules/mobile/data/week.json
// module id = 1429
// module chunks = 0